import { render, staticRenderFns } from "./SingleProfile.vue?vue&type=template&id=4529c927&"
import script from "./SingleProfile.vue?vue&type=script&lang=js&"
export * from "./SingleProfile.vue?vue&type=script&lang=js&"
import style0 from "./SingleProfile.vue?vue&type=style&index=0&id=4529c927&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports